import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { CalendarHeaderComponent } from './calendar-header.component';
import { IconComponent } from '../icon/icon.component';

@NgModule({
  declarations: [CalendarHeaderComponent],
  imports: [CommonModule, MatIconModule, MatMenuModule, IconComponent, MatButtonModule],
})
export class CalendarHeaderModule {}
